import React from 'react';
import { Layout, Drawer, Grid } from 'antd';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import Footer from './Footer';

const { Sider, Header, Content } = Layout;
const { useBreakpoint } = Grid;

const DashboardLayout: React.FC = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [collapsed, setCollapsed] = React.useState(false);
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const sidebarWidth = 280;

  return (
    <Layout style={{ minHeight: '100vh', overflow: 'hidden' }}>
      {!isMobile ? (
        <Sider
          collapsible
          collapsed={collapsed}
          trigger={null}
          width={sidebarWidth}
          style={{
            background: '#ffffff',
            borderRight: '1px solid #d9d9d9',
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            zIndex: 1000,
            height: '100vh',
          }}
          theme="light"
        >
          <Sidebar
            collapsed={collapsed}
            onCollapseToggle={() => setCollapsed(!collapsed)}
            isMobile={false}
          />
        </Sider>
      ) : (
        <Drawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          placement="left"
          closable={false}
          width={sidebarWidth}
          styles={{
            body: { padding: 0, background: '#ffffff', height: '100%' },
          }}
        >
          <Sidebar
            collapsed={false}
            onCollapseToggle={() => {}}
            isMobile={true}
            setDrawerOpen={setDrawerOpen}
          />
        </Drawer>
      )}

      <Layout
        style={{
          marginLeft: !isMobile ? (collapsed ? 80 : sidebarWidth) : 0,
          height: '100vh',
        }}
      >
        <Header
          style={{
            padding: 0,
            position: 'fixed',
            top: 0,
            width: `calc(100% - ${!isMobile ? (collapsed ? 80 : sidebarWidth) : 0}px)`,
            zIndex: 999,
            background: '#fff',
            borderBottom: '1px solid #d9d9d9',
            height: 80,
          }}
        >
          <Navbar isMobile={isMobile} onMenuClick={() => setDrawerOpen(true)} />
        </Header>

        {/* Scrollable area */}
        <Layout
          style={{
            marginTop: 100, // Space for fixed header
            height: 'calc(100vh - 100px)',
            overflow: 'hidden',
          }}
        >
          <Content
            style={{
              padding: '24px',
              overflowY: 'auto',
              height: '100%',
              // marginTop:"10px"
            }}
          >
            <Outlet />
          </Content>

          <Footer />
        </Layout>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
